import {
  toWSDateString,
  WSTable,
  WSTableCell,
  WSTableColumn,
  WSTableItem
} from "@wingspanhq/fe-component-library";
import { Currency } from "@wingspanhq/utils/dist/currency/currencies";
import { formatMoney } from "@wingspanhq/utils/dist/formatMoney";
import React from "react";

import { PaystubHistoryRow } from "../../types";

const EMPTY_VALUE = "—";

type Props = {
  paystubs: PaystubHistoryRow[];
  loading?: boolean;
  onDownload?: (id: string) => void;
  onRowOpen?: (id: string) => void;
};

const columns: WSTableColumn<PaystubHistoryRow>[] = [
  {
    config: { header: { text: "Date" }, gridTemplateSizeMax: "1fr" },
    renderFunction: ({ data }) => (
      <WSTableCell
        text={
          data.date ? toWSDateString(data.date, "monthDayYear") : EMPTY_VALUE
        }
      />
    )
  },
  {
    config: { header: { text: "Paid date" }, gridTemplateSizeMax: "1fr" },
    renderFunction: ({ data }) => (
      <WSTableCell
        text={
          data.paidDate
            ? toWSDateString(data.paidDate, "monthDayYear")
            : EMPTY_VALUE
        }
      />
    )
  },
  {
    config: { header: { text: "Employer name" }, gridTemplateSizeMax: "1fr" },
    renderFunction: ({ data }) => <WSTableCell text={data.employerName} />
  },
  {
    config: { header: { text: "Net pay" }, gridTemplateSizeMax: "1fr" },
    renderFunction: ({ data }) => (
      <WSTableCell text={formatMoney(data.netAmount, Currency.USD)} />
    )
  },
  {
    config: { header: { text: "Gross pay" }, gridTemplateSizeMax: "1fr" },
    renderFunction: ({ data }) => (
      <WSTableCell text={formatMoney(data.grossAmount, Currency.USD)} />
    )
  }
];

export const PaystubHistoryTable: React.FC<Props> = ({
  paystubs,
  loading,
  onDownload,
  onRowOpen
}) => {
  const tableData: WSTableItem<PaystubHistoryRow>[] = paystubs.map(paystub => ({
    id: paystub.id,
    data: paystub
  }));

  return (
    <WSTable<PaystubHistoryRow>
      columns={columns}
      loading={loading}
      rowActions={
        onDownload
          ? item => [
              {
                icon: "download",
                text: "Download",
                onClick: () => onDownload(item.id)
              }
            ]
          : undefined
      }
      tableData={tableData}
      onRowClick={item => onRowOpen?.(item.id)}
    />
  );
};
